import React from "react";
import { Grid, Typography } from "@mui/material";
import { Conversation } from "components";
import { Chat as IChat } from "types";
import { useApp } from "context";
import { useParams } from "react-router-dom";
import { IMessage, IPatient, IUser } from "interfaces";
import { Enums, Helpers, Store } from "utils";

type Props = {};

export const Chat = (props: Props) => {
  const { id, userType } = useParams();
  const { t, theme, service } = useApp();
  const [chats, setChats] = React.useState<IChat[]>([]);
  const [chat, setChat] = React.useState<IChat | null>(null);
  const [selectedIndex, setSelectedIndex] = React.useState<number>(-1);

  const isClinic = Store.sessionStorage.isClinic();

  React.useEffect(() => {
    const fetchData = async () => {
      const receiverId = Number(id);
      const response = await service.message.chats();
      const index = response.findIndex(
        (item: IChat) => item.receiver.userId === receiverId
      );
      if (index === -1) {
        const clinic =
          isClinic && userType === Enums.EnumUser.Patient
            ? ({} as IPatient)
            : await service.clinic.findById(receiverId);
        const newChat = {
          count: 0,
          lastMessage: {
            content: t.message.placeholder.no_message,
            messageTime: Helpers.toISOString(new Date()),
          } as IMessage,
          receiver: {
            userId: receiverId,
            userType: userType ?? Enums.EnumUser.Patient,
            username: clinic.username,
          } as IUser,
        } as IChat;
        response.unshift(newChat);
        setSelectedIndex(0);
      } else {
        setSelectedIndex(index);
      }
      setChats(response);
    };
    fetchData();
  }, []);

  async function handleSelect(chat: IChat) {
    const response = await service.message.chat(chat.receiver.userId);
    const receiver = response.users.find(
      (item: IUser) => item.userId === chat.receiver.userId
    );
    setChat({ ...response, receiver } as IChat);
  }

  return (
    <>
      <div className="qh-header">
        <Grid container spacing={theme.margin.md}>
          <Grid container item xs={12} sm={6}>
            <div className="qh-title">
              <Typography component="span">{t.title.chat}</Typography>
            </div>
          </Grid>
        </Grid>
      </div>
      <div className="qh-content">
        <Grid container spacing={theme.margin.md}>
          <Grid container item xs={12} sm={4} md={3}>
            <Conversation.List
              items={chats}
              selectedIndex={selectedIndex}
              onSelect={handleSelect}
            />
          </Grid>
          <Grid container item xs={12} sm={8} md={9}>
            <Conversation.Chat chat={chat} />
          </Grid>
        </Grid>
      </div>
    </>
  );
};
